import { callFunction } from './compile/compileFunction.ts'
import { callOperator } from './compile/compileOperator.ts'
import type {
  DeprecatedValidationFunctionNode,
  ExpressionNodeWithDeprecated,
  FunctionNode,
  OperatorNode,
} from './syntax/expression_ast.ts'

export type CoreDslParameter = Record<string, unknown>

export function compileExpression(node: ExpressionNodeWithDeprecated, variable: CoreDslParameter): unknown {
  const { type } = node
  switch (type) {
    case 'literal': {
      return node.value
    }
    case 'variable': {
      return dig(variable, node.path)
    }
    case 'func': {
      return compileFunction(node, variable)
    }
    case 'array': {
      return node.elements.map((x) => compileExpression(x, variable))
    }
    case 'operator': {
      return compileOperator(node, variable)
    }
    // deprecated
    case 'function': {
      return compileDeprecatedFunction(node, variable)
    }
    case 'value': {
      return node.value
    }
    case 'recordValue': {
      return dig(variable, node.path)
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      throw new Error(type satisfies never)
    }
  }
}

function compileFunction(node: FunctionNode, variable: CoreDslParameter): unknown {
  const arguments_ = node.args.map((argument) => compileExpression(argument, variable))
  return callFunction(node.name, arguments_, variable)
}

function compileDeprecatedFunction(node: DeprecatedValidationFunctionNode, variable: CoreDslParameter): unknown {
  const arguments_ = node.arguments.map((argument) => compileExpression(argument, variable))
  return callFunction(node.functionType, arguments_, variable)
}

function compileOperator(node: OperatorNode, variable: CoreDslParameter): unknown {
  const left = compileExpression(node.left, variable)
  const right = compileExpression(node.right, variable)
  return callOperator(node.operator, left, right)
}

function dig(x: unknown, path: string[]): unknown {
  if (path.length === 0) {
    return x
  }
  if (typeof x !== 'object' || x === null) {
    // eslint-disable-next-line sonarjs/todo-tag
    return undefined // TODO
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const object = x as Record<string, unknown>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const p = path[0]!
  return dig(object[p], path.slice(1))
}
